import React, { Component } from 'react';
import { connect } from "react-redux";

import LoginWrapper from './Login.style';
import Login from './Login';
import Register from './Register';
import ResetPassword from './ResetPassword';

import { 
  setInnerPagesList, 
  setStepInnerPage 
} from '../../../actions';

class LoginStep extends Component {

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { 
      loginBackButton,
      setInnerPagesList,
      setStepInnerPage,
      innerPage
    } = this.props;

    setInnerPagesList([
      { name: 'login',    back: '', backButton: loginBackButton },
      { name: 'register', back: 'login' },
      { name: 'resetPassword', back: 'login' },
    ]);
    setStepInnerPage(innerPage);
  }

  page() {
    const { 
      stepInnerPage
    } = this.props;

    switch (stepInnerPage.name) {
      case 'login':
        return <Login />;
      case 'register':
        return <Register />;
      case 'resetPassword':
        return <ResetPassword />;
    };
    return <div/>;
  }

  render() {
    return (
      <LoginWrapper>
        {this.page()}
      </LoginWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    stepInnerPage: state.steps.stepInnerPage
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setInnerPagesList: (pages) => {
      dispatch(setInnerPagesList(pages));
    },
    setStepInnerPage: (pages) => {
      dispatch(setStepInnerPage(pages));
    },
  };
};

LoginStep.defaultProps = {
  innerPage: 'login',
  loginBackButton: true
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginStep);
